<template>
  <div class="page-layout admin-layout">
    <div class="admin-layout-inner">
      <aside class="admin-sidebar panel">
        <h1 class="admin-sidebar-title">Администрирование</h1>
        <nav class="admin-nav" aria-label="Разделы админки">
          <router-link
            v-for="item in navItems"
            :key="item.name"
            class="admin-nav-link"
            :class="{ 'admin-nav-link--active': route.name === item.name }"
            :to="{ name: item.name }"
          >
            {{ item.label }}
          </router-link>
        </nav>
      </aside>
      <div class="admin-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router'

const route = useRoute()

const navItems = [
  { name: 'admin-users', label: 'Пользователи' },
  { name: 'admin-tracks', label: 'Треки' },
  { name: 'admin-trips', label: 'Поездки' },
  { name: 'admin-comments', label: 'Комментарии' },
  { name: 'admin-moderation-actions', label: 'Журнал модерации' },
]
</script>
